module.exports = __webpack_public_path__ + "static/media/zing_network.b1adced3.jpg";